export const queryDomainProviders = `
query DomainProviders($paging: CursorPaging, $filter: ProviderFilter) {
  domainProviders(paging: $paging, filter: $filter) {
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      node {
        id
        image
        lastName
        phone
        firstName
        email
        services {
        id
        }
      }
    }
  }
}
`